<template>
    <section
        ref="section12"
        :class="[
            Object.keys(validationErrors).length > 0 ? 'has-errors' : '',
            'mx-auto flex h-full flex-col',
        ]"
    >
        <v-add-listing-head :routes="routes" :step="13"></v-add-listing-head>
        <main
            class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
        >

            <figure class="relative flex max-w-3xl flex-col gap-11 lg:w-full">
                <figure class="ml-auto mr-auto flex w-full max-w-lg gap-3">
                    <div><v-icon icon="house-user" size="8"></v-icon></div>
                    <div class="flex flex-col justify-center">
                        <div class="mr-6 text-heading-3-desktop">
                            Ali je nepremičnina trenutno oddana?
                        </div>
                    </div>

                    <v-lightbox is-authenticated footerless>
                        <template v-slot:trigger>
                            <div
                                class="absolute right-0 top-0 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-white shadow hover:bg-green-25"
                            >
                                <v-icon icon="question-mark" size="4"></v-icon>
                            </div>
                        </template>
                        <template v-slot:head>
                            <div class="flex items-start">
                                <v-icon
                                    icon="question-mark"
                                    class="mr-2.5"
                                    size="4.5"
                                ></v-icon>
                                <div>
                                    Dodatne informacije
                                </div>
                            </div>
                        </template>
                        <template v-slot:content>
                            <p class="mb-[10px] text-icon-text-medium">
                                Ali je nepremičnina trenutno oddana?
                            </p>
                            <p class="mb-8 text-body-regular">
                                Potrebujemo podatek, ali je nepremičnina trenutno oddana. Za zainteresirano stranko je to zelo pomemben podatek.
                            </p>
                        </template>
                    </v-lightbox>
                </figure>
                <figure class="ml-auto mr-auto w-full max-w-lg">
                    <form method="POST" :action="routes.submitForm" id="select-leased-status">
                        <v-csrf-token></v-csrf-token>
                        <figure>
                            <figure
                                class="grid grid-cols-2 grid-rows-1 gap-4 lg:flex lg:grid-cols-2 lg:flex-wrap lg:justify-center lg:gap-6"
                            >
                                <div
                                    name="da"
                                    :class="[
                                        'tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]',
                                        validationErrors.vermietet
                                            ? 'has-errors'
                                            : '',
                                    ]"
                                >
                                    <input
                                        type="radio"
                                        name="vermietet"
                                        id="aliJeNepremicninaTrenutnoOddana-da"
                                        value="1"
                                        class="hidden"
                                        v-model="leased"
                                    />

                                    <label
                                        for="aliJeNepremicninaTrenutnoOddana-da"
                                        class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all"
                                    >
                                        <v-icon
                                            icon="circle-check"
                                            size="5"
                                        ></v-icon>
                                        <span
                                            class="pointer-events-none select-none"
                                            >Da</span
                                        >
                                    </label>
                                </div>
                                <div
                                    name="v-gradnji"
                                    :class="[
                                        'tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]',
                                        validationErrors.vermietet
                                            ? 'has-errors'
                                            : '',
                                    ]"
                                >
                                    <input
                                        type="radio"
                                        name="vermietet"
                                        id="aliJeNepremicninaTrenutnoOddana-ne"
                                        value="0"
                                        class="hidden"
                                        v-model="leased"
                                    />

                                    <label
                                        for="aliJeNepremicninaTrenutnoOddana-ne"
                                        class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all"
                                    >
                                        <v-icon icon="cancel" size="5"></v-icon>

                                        <span
                                            class="pointer-events-none select-none"
                                            >Ne</span
                                        >
                                    </label>
                                </div>
                            </figure>
                            <figure
                                class="ml-auto mr-auto max-w-lg mt-11"
                                v-if="leased == 1"
                            >
                                <ul
                                    class="grid grid-cols-4 flex-col gap-x-5 gap-y-8"
                                >
                                    <li class="col-span-4">
                                        <div
                                            :class="[
                                                'input group relative flex flex-col gap-[10px]',
                                                validationErrors.mieteinnahmen_pro_monat
                                                    ? 'has-errors'
                                                    : '',
                                            ]"
                                        >
                                            <label
                                                for="netoNajemnina"
                                                class="w-full text-body-medium-button"
                                            >
                                                <div
                                                    class="label flex flex-col gap-[10px]"
                                                >
                                                    <div
                                                        class="flex items-center gap-3"
                                                    >
                                                        <v-icon
                                                            icon="payments"
                                                            size="4"
                                                        ></v-icon>
                                                        <span>
                                                            Neto najemnina
                                                            <sup>*</sup></span
                                                        >
                                                    </div>
                                                </div>
                                            </label>
                                            <input
                                                id="netoNajemnina"
                                                type="number"
                                                name="mieteinnahmen_pro_monat"
                                                placeholder="Neto najemnina"
                                                v-model="lease"
                                            />
                                            <div
                                                class="absolute bottom-[18px] right-6 text-body-medium-button"
                                                :class="lease ? 'text-black-78' : 'text-black-40'"
                                                >€/mesec</div
                                            >
                                        </div>
                                    </li>
                                </ul>
                            </figure>
                        </figure>
                    </form>
                </figure>
            </figure>

        </main>
        <v-add-listing-foot>
            <a
                @click="submitForm('select-leased-status')"
                :class="[
                    'button button--md h-[48px] w-[240px] px-6',
                    validated ? '' : 'button button--gray',
                ]"
            >
                <label class="text-small-text-medium">Nadaljujte</label>
                <v-icon icon="arrow-right" size="4"></v-icon>
            </a>
        </v-add-listing-foot>
    </section>
</template>
<script>
import AddListingFootVue from "../AddListingFoot.vue";
import AddListingHeadVue from "../AddListingHead.vue";

export default {
    components: {
        "v-add-listing-foot": AddListingFootVue,
        "v-add-listing-head": AddListingHeadVue,
    },

    props: {
        old: {
            type: Object,
            required: false,
            default: {},
        },
        routes: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        stepData: {
            type: Object,
            required: true,
            default: {},
        },
    },
    data() {
        return {
            leased: null,
            lease: null,
        };
    },
    mounted() {
        this.leased = this.old.vermietet
            ? this.old.vermietet
            : this.stepData.vermietet != null
            ? Number(this.stepData.vermietet)
            : null;
        this.lease = this.old.mieteinnahmen_pro_monat
            ? this.old.mieteinnahmen_pro_monat
            : this.stepData.mieteinnahmen_pro_monat;
    },
    computed: {
        leaseTypeCasted() {
            return this.leaseType ? 1 : 0;
        },
        validated() {
            if (this.leased == null) return false;

            if (this.leased == 1 && !this.lease) return false;

            return true;
        },
    },
    methods: {
        submitForm(formId) {
            if (this.validated) document.getElementById(formId).submit();
        },
    },
};
</script>
